import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { ServerAction } from '@cbridge-packages/server';
import { ClientAction } from '@cbridge-packages/client';
import { detailsSidebarResourceIdSelector, detailsSidebarStoreSelector } from '@cbridge-packages/details-sidebar';

type IState =
  & IGetSelectorStateType<typeof detailsSidebarStoreSelector>;

export const reloadServerDetailsEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOf(
    ServerAction.createServerStream.done,
    ServerAction.updateServerStream.done,
    ServerAction.removeServerStream.done,
    ClientAction.update.done,
    ClientAction.remove.done,
  ),
  withLatestFrom(state$),
  mergeMap(([, state]) => {
    const resourceId = detailsSidebarResourceIdSelector(state);

    return [
      ServerAction.load.started({ serverId: String(resourceId) }),
    ];
  }),
);
